var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add order - Retruning user product  ",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 1162,
    transform: "translate(-260 -899)",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000006791"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    filter: "url(#filter0_ddd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -240,
    y: -144,
    width: 320,
    height: 212,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -239.5,
    y: -143.5,
    width: 319,
    height: 211,
    rx: 7.5,
    stroke: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Small card with label"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card with label"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -239,
    y: -27,
    width: 248,
    height: 70,
    rx: 8,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Label"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.75,
    y: -10.75,
    width: 74.5,
    height: 38.5,
    rx: 3.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "subtract-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5026 15.1654C12.1693 15.1654 15.1693 12.1654 15.1693 8.4987C15.1693 4.83203 12.1693 1.83203 8.5026 1.83203C4.83594 1.83203 1.83594 4.83203 1.83594 8.4987C1.83594 12.1654 4.83594 15.1654 8.5026 15.1654Z",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.83594 8.5H11.1693",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -7.75,
    y: -10.75,
    width: 74.5,
    height: 38.5,
    rx: 3.75,
    stroke: "#1C1C1C",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_0_1",
    x: -263,
    y: -151,
    width: 366,
    height: 265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521569 0 0 0 0 0.521569 0 0 0 0 0.521569 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521569 0 0 0 0 0.521569 0 0 0 0 0.521569 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521569 0 0 0 0 0.521569 0 0 0 0 0.521569 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 1162,
    fill: "white",
    transform: "translate(-260 -899)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractCircle);
export default __webpack_public_path__ + "static/media/subtract-circle.e1d95e808efea050ff8250ed97012e0b.svg";
export { ForwardRef as ReactComponent };